<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="analyze-trend">
    <!-- <pre>{{artefact}}</pre> -->
    <div class="vx-row" v-if="['CPI', 'GPI', 'SPI'].includes(artefact.type) && selectedUnits.series &&  selectedUnits.series.length > 0">
      <!-- LINE CHART -->
      <div class="vx-col w-full mb-base">
        <vx-card :title="artefact.query" subtitle>
          <template slot="actions">
            <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
              <!-- <feather-icon
                icon="DownloadIcon"
                class="cursor-pointer"
                v-if="selectedUnits.series.length > 0"
                :svgClasses="[{'text-success stroke-current': selectedUnits.series.length > 0}, 'w-5', 'h-5 mr-4']"
                @click.stop="activePrompt=true" /> -->


              <!-- <feather-icon
                icon="LayersIcon"
                class="cursor-pointer"
                :svgClasses="[{'text-success stroke-current': payload.type = 'CPI'}, 'w-5', 'h-5 mr-4']"
                @click.stop="getInsightInfo('CPI')" />

              <feather-icon
                icon="UserIcon"
                class="cursor-pointer"
                :svgClasses="[{'text-success stroke-current': payload.type = 'GPI'}, 'w-5', 'h-5 mr-4']"
                @click.stop="getInsightInfo('GPI')" />

              <feather-icon
                icon="TagIcon"
                class="cursor-pointer"
                :svgClasses="[{'text-success stroke-current': payload.type = 'SPI'}, 'w-5', 'h-5 mr-4']"
                @click.stop="getInsightInfo('SPI')" /> -->

            </div>

            <!-- <vs-button @click="activePrompt=true">Export</vs-button> -->
          </template>
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="bar"
              height="350"
              :options="plotBar.chartOptions"
              :series="selectedUnits.series"
            ></vue-apex-charts>
            <!-- <vue-apex-charts type="bubble" height="350" :options="bubbleChart.chartOptions" :series="bubbleChart.series"></vue-apex-charts> -->
            <!-- <vue-apex-charts
              type="area"
              height="310"
              :options="selectedUnits.chartOptions"
              :series="selectedUnits.series"
            ></vue-apex-charts>-->
          </div>
        </vx-card>
      </div>

      <!-- TOP 5 CHART -->
      <!-- <div class="vx-col w-full md:w-1/3 mb-base">
        <vx-card :title="(artefact.type === 'SFM' ? 'Top Selling Skus' : 'Slow Movingh Skus')" subtitle>
            <div slot="no-body" class="p-6 pb-10">
              <vue-apex-charts type="donut" height="325" :options="selectedUnits.sku.chartOptions" :series="selectedUnits.sku.series"></vue-apex-charts>
            </div>
        </vx-card>
      </div>-->
    </div>
    <div
      class="vx-row"
      v-if="['MPI'].includes(artefact.type) && selectedUnits.series &&  selectedUnits.series.length > 0"
    >
      <!-- LINE CHART -->
      <div class="vx-col w-full mb-base">
        <vx-card :title="artefact.query" subtitle>
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="area"
              height="310"
              :options="selectedUnits.chartOptions"
              :series="selectedUnits.series"
            ></vue-apex-charts>
          </div>
        </vx-card>
      </div>

      <!-- TOP 5 CHART -->
      <!-- <div class="vx-col w-full md:w-1/3 mb-base">
        <vx-card :title="(artefact.type === 'SFM' ? 'Top Selling Skus' : 'Slow Movingh Skus')" subtitle>
            <div slot="no-body" class="p-6 pb-10">
              <vue-apex-charts type="donut" height="325" :options="selectedUnits.sku.chartOptions" :series="selectedUnits.sku.series"></vue-apex-charts>
            </div>
        </vx-card>
      </div>-->
    </div>
    <div class="vx-row" v-if="['SST', 'CST', 'BST', 'CSST', 'BSST'].includes(artefact.type)">
      <!-- LINE CHART -->
      <div class="vx-col w-full mb-base">
        <vx-card title="Sale Trend" subtitle="Sale Trend by Week">
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="line"
              height="355"
              :options="trendLine.chartOptions"
              :series="makeUnitStatsData()"
            />
          </div>
        </vx-card>
      </div>

      <!-- RADIAL CHART -->
      <!-- <div class="vx-col w-full md:w-1/3 mb-base"></div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueApexCharts from "vue-apexcharts";

import { fetchArtefact } from "../shared/services";
import appConfig from "@/../appConfig.js";

const themeColors = appConfig.chart.colors;

export default {
  props: {
    artefact: { type: Object, required: true },
    type: { type: String, required: true }
  },
  components: {
    VueApexCharts,
    VuePerfectScrollbar
  },
  data() {
    return {
      priceIndex: [],
      isLoading: true,
      payload: {
        tags: [],
        dateRange: {
          startDate: "05/03/2019",
          endDate: "08/03/2019"
        },
        page: {
          size: 20,
          pos: 1
        },
        query: "",
        mode: "quantity",
        type: "CPI",
        res: {}
      },
      units: {
        headers: [],
        data: []
      },
      selectedUnits: {
        label: "Performance",
        chartOptions: {},
        series: []
      },
      trendBar: {
        series: [
          {
            name: "",
            data: []
          }
        ],
        chartOptions: {
          annotations: {
            position: "front",
            yaxis: [
              {
                y: 95.0,
                borderColor: "#2698FF",
                label: {
                  borderColor: "#2698FF",
                  style: {
                    color: "#fff",
                    background: "#2698FF"
                  },
                  text: "Average Accuracy "
                }
              }
            ]
          },
          colors: themeColors,
          chart: {
            zoom: {
              enabled: true,
              type: "xy"
            },
            toolbar: {
              show: true,
              autoSelected: "zoom"
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
              columnWidth: "55%"
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: false,
            width: 2,
            colors: ["transparent"]
          },
          grid: {
            show: false
          },
          xaxis: {
            labels: {
              show: false,
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false
            },
            title: {
              show: false,
              text: "Monitor Event Dates",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
            // categories: []
          },
          yaxis: {
            title: {
              text: "Monitor Accuracy ( % )"
            }
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 100]
            }
          },
          tooltip: {
            y: {
              // formatter: function(val) {
              //   return "$ " + val + " thousands"
              // }
            }
          }
        }
      },
      trendLine: {
        series: [
          {
            name: "",
            data: []
          }
        ],
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: true }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2]
          },
          grid: {
            borderColor: "#e7e7e7"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            type: "datetime",
            tickAmount: 15,
            title: {
              text: "Week"
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ["Jan '18", "Feb '18", "Mar '18", "Apr '18", "May '18", "Jun '18", "Jul '18", "Aug '18", "Sep '18", "Oct '18", "Nov '18", "Dec '18", "Jan '19", "Feb '19", "Mar '19", "Apr '19", "May '19"],
            // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"],
            // categories: ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
            // categories:[],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            title: {
              text: "Monitoring Accuracy ( % )",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            },
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999
                  ? (val / 1000).toFixed(1) + "k"
                  : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
              }
            }
          },
          tooltip: {
            shared: true,
            intersect: false
            // x: { show: false }
          }
        }
      },
      plotBar: {
        series: [
          {
            data: []
          }
        ],
        chartOptions: {
          colors: themeColors,
          chart: {
            zoom: {
              enabled: true,
              type: "xy"
            },
            toolbar: {
              show: true,
              autoSelected: "zoom"
            }
          },
          plotOptions: {
            bar: {
              horizontal: true,
              // endingShape: "rounded",
              columnWidth: "55%"
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: false,
            width: 2,
            colors: ["transparent"]
          },
          grid: {
            show: false
          },
          xaxis: {
            labels: {
              show: true,
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false
            },
            title: {
              show: true,
              text: "Price Index",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
            // categories: []
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              stops: [0, 100]
            }
          },
          tooltip: {
            y: {
              // formatter: function(val) {
              //   return "$ " + val + " thousands"
              // }
            }
          }
        }
      },
      barChart: {
        series: [{
            data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380]
        }],
        chartOptions: {
          colors: themeColors,
          plotOptions: {
            bar: {
              horizontal: true,
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: ['South Korea', 'Canada', 'United Kingdom', 'Netherlands', 'Italy', 'France', 'Japan',
              'United States', 'China', 'Germany'
            ],
          }
        }
      },
      competeGraph: {
        series: [
          {
            data: []
          }
        ],
        chartOptions: {
          chart: {
            height: 330,
            type: "bar",
            toolbar: { show: false }
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 100
            }
          },
          plotOptions: {
            bar: {
              // barHeight: '100%',
              distributed: true,
              horizontal: true,
              dataLabels: {
                position: "right"
              }
            }
          },
          colors: [themeColors[0]],
          fill: {
            type: "gradient",
            gradient: {
              // enabled: true,
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 0.5,
              gradientToColors: [themeColors[1]],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100]
            }
          },
          dataLabels: {
            enabled: true,
            textAnchor: "start",
            style: {
              colors: ["#626262"]
            },
            formatter: function(val, opt) {
              return (
                "~ " + opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
              );
            },
            dropShadow: {
              // enabled: true
            }
          },
          stroke: {
            show: false,
            width: 2,
            colors: ["transparent"]
          },
          xaxis: {
            labels: {
              show: false,
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false
            },
            title: {
              show: true,
              text: "Price Index",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            },
            categories: []
          },
          yaxis: {
            labels: {
              show: false
            }
          },
          title: {
            // text: 'Custom DataLabels',
            // align: 'center',
            // floating: true
          },
          subtitle: {
            // text: 'Category Names as DataLabels inside bars',
            // align: 'center',
          },
          tooltip: {
            theme: "light",
            x: {
              show: true
            },
            y: {
              title: {
                formatter: function() {
                  return "Price Index ";
                }
              }
            }
          }
        }
      },

      fileName: "",
      formats:["xlsx", "csv", "txt"] ,
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["Row", "Sku Id", "Desc", "Category", "Brand", "Cost to Company","Inventory"],
      headerVal: ["row", "sku_id", "desc", "cat_lookup", "brand","c2c", "inventory"],
      activePrompt: false      
    };
  },
  computed: {
    // ...mapGetters({ items: "analyze/artefactUnit" })
  },
  methods: {
    fetchUnits(chartMode, chartType, isAnnotate, seriesName) {
      this.units.data = this.formatItemsData(
        chartMode,
        chartType,
        isAnnotate,
        seriesName
      );
      
      this.selectedUnits = {
        label: "Performance",
        chartOptions: {},
        series: []
      };

      this.selectedUnits.chartOptions = this.chartOptions(
        chartMode,
        chartType,
        isAnnotate
      );
      this.selectedUnits.series = this.seriesData(
        chartMode,
        chartType,
        seriesName
      );
    },
    formatItemsData(chartMode, chartType, isAnnotate, seriesName) {
      let units = [];
      if (chartMode === "trend") {
        units = this.artefact.res.table.map(item => item[0]);
      } else if (chartMode === "compare") {
        units = this.priceIndex && this.priceIndex.length > 0 ? this.priceIndex : this.artefact.res.priceindex.price_index;
        units.sort(function(a, b) {
          return a.index - b.index;
        });
      }

      return units;
    },
    chartOptions(chartMode, chartType, isAnnotate) {
      let unitsData = this.units.data;
      let typeData = [];

      if (chartMode === "trend") {
        for (let i = 0; i < unitsData.length; i++) {
          let date = this.$options.filters.date(unitsData[i].date, true);
          typeData.push(date);
        }
      } else if (chartMode === "compare") {
        for (let i = 0; i < unitsData.length; i++) {
          let filterData = unitsData[i].key;
          typeData.push(filterData);
        }
      }

      if (chartType === "bar") {
        if (isAnnotate) {
          this.trendBar.chartOptions.annotations.yaxis[0].y = this.artefact.res.Average;
          this.trendBar.chartOptions.annotations.yaxis[0].label.text =
            "Average Accuracy ( " +
            this.$options.filters.numFormat(
              this.artefact.res.Average / 100,
              "0.00 %"
            ) +
            " )";
        }
        this.trendBar.chartOptions.xaxis.categories = typeData;
        return this.trendBar.chartOptions;
      } else if (chartType === "hbar") {
        this.plotBar.chartOptions.xaxis.categories = typeData;
        return this.plotBar.chartOptions;
      }
    },
    seriesData(chartMode, chartType, seriesName) {
      let unitsData = this.units.data;
      let seriesData = [
        {
          name: seriesName,
          data: []
        }
      ];

      for (let i = 0; i < unitsData.length; i++) {
        if (chartType === "bar") {
          seriesData[0].data.push(
            this.$options.filters.numFormat(
              unitsData[i].accuracy / 100,
              "0.00 %"
            )
          );
        } else if (chartType === "hbar") {
          seriesData[0].data.push(
            this.$options.filters.numFormat(
              unitsData[i].index / 100,
              "0.00 %"
            )
          );
        }
      }

      return seriesData;
    },
    getInsightInfo(callType) {
      this.payload.type = callType;
      this.isLoading = true;
      this.$vs.loading({
        // background: this.backgroundLoading,
        // color: this.colorLoading,
        // container: "#exploreButton",
        // scale: 0.45,
        type: "radius"
      });
      fetchArtefact(this.payload)
        .then(res => {
          this.priceIndex = res.priceindex.price_index;
          this.isLoading = false;
          this.fetchUnits("compare", "hbar", false, "Price Index");

      let priceIndex = [];
      let chartHeightIndex = 200;
      
      priceIndex = Object.assign(priceIndex, this.priceIndex);

      priceIndex.sort(function(a, b) {
        return b.index - a.index;
      });

      // trend = trend.slice(1, 3);

      let xCat = priceIndex.map(d => d.key);
      let series = [];
      let sData = {
        data: []
      };
      sData.data = trend.map(d => Number(d.index));

      series.push(sData);

      this.plotBar.chartOptions = {
        ...this.plotBar.chartOptions,
        ...{
          chart: {
            height: chartHeightIndex * Math.ceil(this.priceIndex.length / 15),
            type: "bar",
            toolbar: { show: false }
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 100
            }
          },
          plotOptions: {
            bar: {
              // barHeight: '100%',
              distributed: true,
              horizontal: true,
              dataLabels: {
                position: "right"
              }
            }
          },
          legend: {
            show: false
          },
          xaxis: {
            labels: {
              show: false,
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false
            },
            categories: xCat
          }
        }
      };

          this.selectedUnits.chartOptions = this.plotBar.chartOptions;

          this.$vs.loading.close();
        })
        .catch(error => {
          this.priceIndex = [];
          this.isLoading = false;
          this.$vs.loading.close();
          throw new Error(error);
        });
    },


    exportToExcel() {
      import('@/app/shared/vendor/Export2Excel').then(excel => {
        const list = this.alertContainer
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    clearFields() {
      this.filename = "",
      this.cellAutoWidth = true,
      this.selectedFormat = "xlsx"
    }
  },
  created() {},
  mounted() {
    if (["MPI"].includes(this.artefact.type)) {
      this.fetchUnits("trend", "bar", true, "Monitoring Accuracy");
    } else if (["CPI", "GPI", "SPI"].includes(this.artefact.type)) {
      this.fetchUnits("compare", "hbar", false, "Price Index");
    } else if (
      ["SST", "CST", "BST", "CSST", "BSST"].includes(this.artefact.type)
    ) {
      this.makeUnitStatsData();
    }
  }
};
</script>

<style lang="scss">
#analyze-trend {
  .reportrange-text {
    background: transparent;
    cursor: pointer;
    padding: 0px;
    border: 0px;
  }
}
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      // border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.chat-card-log {
  height: 400px;

  .chat-sent-msg {
    background-color: #f2f4f7 !important;
  }
}
</style>
